import { render, staticRenderFns } from "./DetailsActionButton.vue?vue&type=template&id=7327b3ed&scoped=true"
import script from "./DetailsActionButton.vue?vue&type=script&lang=ts"
export * from "./DetailsActionButton.vue?vue&type=script&lang=ts"
import style0 from "./DetailsActionButton.vue?vue&type=style&index=0&id=7327b3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327b3ed",
  null
  
)

export default component.exports